import { axiosInstance } from '../utils/axios';

export const getItemWithUserData = (
  { path: { orgId, streamId, channelId, streamItemId } },
  extraData,
) =>
  Promise.all([
    axiosInstance.get(
      `/${orgId}/${streamId}/${channelId}/items/${streamItemId}`,
      {
        ...extraData,
        params: {
          ...extraData?.params,
          refresh: Math.random(),
        },
      },
    ),
    axiosInstance.get(
      `/${orgId}/${streamId}/${channelId}/items/${streamItemId}/userdata`,
      {
        ...extraData,
        params: {
          ...extraData?.params,
          refresh: Math.random(),
        },
      },
    ),
  ]);

export const postItem = (
  {
    path: { orgId, streamId, channelId },
    body: {
      type: itemType,
      published,
      itemTags,
      itemMentions,
      refId,
      summary,
      content,
    },
    params: {
      rebuzzable,
      commentable,
      public: isPublic,
      locked,
      unlockCoinsValue,
      unlockCurrencyValue,
      timeline,
      pinnedUntil,
      withPinnedComment,
      anchorCID,
      threadWithSiblingCID,
      isOpenSource,
    },
  },
  extraData,
) =>
  axiosInstance
    .post(
      `/${orgId}/${streamId}/${channelId}/items`,
      {
        type: itemType,
        published,
        itemTags,
        itemMentions,
        refId,
        summary,
        content,
      },
      {
        ...extraData,
        params: {
          rebuzzable,
          commentable,
          public: isPublic,
          locked,
          unlockCoinsValue,
          unlockCurrencyValue,
          timeline,
          pinnedUntil,
          withPinnedComment,
          anchorCID,
          threadWithSiblingCID,
          isOpenSource,
        },
      },
    )
    .then(response => {
      // '/{orgId}/{streamId}/{channelId}/items/{streamItemId}'
      const [, , , , , streamItemId] = response.headers.location.split('/');
      return getItemWithUserData({
        path: { orgId, streamId, channelId, streamItemId },
      });
    });

export const postStreamItem = (
  {
    path: { orgId, streamId, channelId, streamItemId },
    body,
    params: {
      method,
      pinnedUntil,
      rebuzzable,
      commentable,
      isPublic,
      channelPath,
      anchorPath,
    },
  },
  extraData,
) =>
  axiosInstance
    .post(`/${orgId}/${streamId}/${channelId}/items/${streamItemId}`, body, {
      ...extraData,
      params: {
        method,
        pinnedUntil,
        rebuzzable,
        commentable,
        public: isPublic,
        channelPath,
        anchorPath,
      },
    })
    .then(() =>
      getItemWithUserData({
        path: { orgId, streamId, channelId, streamItemId },
      }),
    );

export const putItem = (
  {
    path: { orgId, streamId, channelId, streamItemId },
    body: { published, itemTags, itemMentions, summary, content },
    params: {
      isPublic,
      hash,
      locked,
      unlockCoinsValue,
      unlockCurrencyValue,
      timeline,
      pinnedUntil,
      isOpenSource,
    },
  },
  extraData,
) =>
  axiosInstance
    .put(
      `/${orgId}/${streamId}/${channelId}/items/${streamItemId}`,
      {
        summary,
        content,
        itemMentions,
        itemTags,
        published,
        type: 'source',
      },
      {
        ...extraData,
        params: {
          ...extraData?.params,
          hash,
          public: isPublic,
          locked,
          unlockCoinsValue,
          unlockCurrencyValue,
          timeline,
          pinnedUntil,
          isOpenSource,
        },
      },
    )
    .then(() =>
      getItemWithUserData({
        path: { orgId, streamId, channelId, streamItemId },
      }),
    );

export const getTimeline = extraData =>
  Promise.all([
    axiosInstance('/timeline', {
      ...extraData,
      params: {
        ...extraData?.params,
      },
    }),
    axiosInstance('/timeline/userdata', {
      ...extraData,
      params: {
        ...extraData?.params,
      },
    }),
  ]);

export const getItems = ({ orgId, streamId, channelId }, extraData) =>
  Promise.all([
    axiosInstance.get(`/${orgId}/${streamId}/${channelId}/items`, {
      ...extraData,
      params: {
        ...extraData?.params,
        refresh: Math.random(),
      },
    }),
    axiosInstance.get(`/${orgId}/${streamId}/${channelId}/items/userdata`, {
      ...extraData,
      params: {
        ...extraData?.params,
        refresh: Math.random(),
      },
    }),
  ]);

export const checkForNewItems = (
  { path: { orgId, streamId, channelId }, params: { channelHash } },
  extraData,
) =>
  axiosInstance.head(
    `/${orgId}/${streamId}/${channelId}/items?hash=${channelHash}`,
    extraData,
  );

export const getItemSource = (
  { orgId, streamId, channelId, streamItemId },
  extraData,
) =>
  axiosInstance.get(
    `/${orgId}/${streamId}/${channelId}/items/${streamItemId}/source`,
    extraData,
  );

export const getItemRendered = (
  { orgId, streamId, channelId, streamItemId },
  extraData,
) =>
  axiosInstance.get(
    `/${orgId}/${streamId}/${channelId}/items/${streamItemId}/rendered`,
    {
      ...extraData,
      params: {
        ...extraData?.params,
        refresh: Math.random(),
      },
    },
  );

export const deleteItem = (
  { path: { orgId, streamId, channelId, streamItemId } },
  extraData,
) =>
  axiosInstance.delete(
    `/${orgId}/${streamId}/${channelId}/items/${streamItemId}`,
    extraData,
  );

export const getItemsUserData = ({ orgId, streamId, channelId }, extraData) =>
  axiosInstance.get(
    `/${orgId}/${streamId}/${channelId}/items/userdata`,
    extraData,
  );

export const getItemUserData = (
  { orgId, streamId, channelId, streamItemId },
  extraData,
) =>
  axiosInstance.get(
    `/${orgId}/${streamId}/${channelId}/items/${streamItemId}/userdata`,
    extraData,
  );

export const getItemLockedContent = (
  { path: { orgId, streamId, channelId, streamItemId } },
  extraData,
) =>
  axiosInstance.get(
    `/${orgId}/${streamId}/${channelId}/items/${streamItemId}/content`,
    extraData,
  );

export const postItemReaction = (
  {
    path: { orgId, streamId, channelId, streamItemId },
    body: { reactionType },
  },
  extraData,
) =>
  axiosInstance
    .post(
      `/${orgId}/${streamId}/${channelId}/items/${streamItemId}/reaction`,
      { reactionType },
      extraData,
    )
    .then(() =>
      getItemWithUserData({
        path: { orgId, streamId, channelId, streamItemId },
      }),
    );

export const patchItemReaction = (
  {
    path: { orgId, streamId, channelId, streamItemId },
    body: { reactionType },
  },
  extraData,
) =>
  axiosInstance
    .patch(
      `/${orgId}/${streamId}/${channelId}/items/${streamItemId}/reaction`,
      { reactionType },
      extraData,
    )
    .then(() =>
      getItemWithUserData({
        path: { orgId, streamId, channelId, streamItemId },
      }),
    );

export const postItemBookmark = (
  { path: { orgId, streamId, channelId, streamItemId }, params: { tags } },
  extraData,
) =>
  axiosInstance
    .post(
      `/${orgId}/${streamId}/${channelId}/items/${streamItemId}/bookmark`,
      null,
      {
        ...extraData,
        params: {
          ...extraData?.params,
          tags: tags.join(',') || null,
        },
      },
    )
    .then(() =>
      getItemWithUserData({
        path: { orgId, streamId, channelId, streamItemId },
      }),
    );

export const deleteItemBookmark = (
  { path: { orgId, streamId, channelId, streamItemId } },
  extraData,
) =>
  axiosInstance
    .delete(
      `/${orgId}/${streamId}/${channelId}/items/${streamItemId}/bookmark`,
      extraData,
    )
    .then(() =>
      getItemWithUserData({
        path: { orgId, streamId, channelId, streamItemId },
      }),
    );

export const getSubscription = (
  { path: { orgId, streamId, channelId, subscriptionId } },
  extraData,
) =>
  axiosInstance.get(
    `/${orgId}/${streamId}/${channelId}/subscription/${subscriptionId}`,
    {
      ...extraData,
      params: {
        ...extraData?.params,
        refresh: Math.random(),
      },
    },
  );

export const postSubscription = (
  {
    path: { orgId, streamId, channelId },
    body: { promotion, payment, name, description, moderate, roles },
    params,
  },
  extraData,
) =>
  axiosInstance.post(
    `${orgId}/${streamId}/${channelId}/subscription`,
    {
      promotion,
      payment,
      name,
      description,
      moderate,
      roles,
    },
    {
      ...extraData,
      params: {
        ...params,
        refresh: Math.random(),
      },
    },
  );
